<template>
  <Teleport to="body">
    <div
      v-if="show"
      class="pointer-events-none fixed top-4 right-4 z-[10050] max-w-[min(22rem,calc(100vw-2rem))]"
      aria-live="polite"
    >
      <div
        class="pointer-events-auto rounded-lg border px-3 py-2 text-left text-xs font-semibold leading-snug text-white shadow-2xl break-words whitespace-pre-line sm:px-4 sm:py-2 sm:text-sm"
        :class="
          variant === 'error'
            ? 'border-red-900 bg-red-600'
            : 'border-emerald-800 bg-emerald-600'
        "
      >
        <slot />
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  name: 'FinanceToast',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: 'success',
      validator: (v) => v === 'success' || v === 'error'
    }
  }
}
</script>
